import React, { ReactNode } from 'react';
import { Button, Row } from 'antd';
import { Icon } from '@ant-design/compatible';
import { useHistory } from 'react-router';

type Props = {
  title: string | '';
  closeFunction: (event: any) => any;
  nextId?: string | null;
  prevId?: string | null;
  baseUrl?: string;
  children?: ReactNode;
};

export const TopBar = ({ title, closeFunction, nextId, prevId, baseUrl, children }: Props) => {
  let history = useHistory();

  return (
    <Row
      className="w-full justify-center items-center relative bg-white"
      style={{
        minHeight: '58px',
        borderBottom: '1px solid #DCDCDC',
      }}>
      {prevId && (
        <Button
          type="link"
          disabled={!prevId}
          onClick={() => {
            history.push(`${baseUrl}/${prevId}`);
          }}>
          <Icon type="left" />
        </Button>
      )}
      <span style={{ fontSize: 15 }}>{title}</span>
      {nextId && (
        <Button
          type="link"
          disabled={!nextId}
          onClick={() => {
            history.push(`${baseUrl}/${nextId}`);
          }}>
          <Icon type="right" />
        </Button>
      )}
      {children}
      <Button type="link" className="text-xl absolute p-0 right-10" onClick={closeFunction}>
        <Icon type="close" className="text-black" />
      </Button>
    </Row>
  );
};
